export default {
  hidden_rates:
    'Alcuni metodi di pagamento hanno anche una tariffa propria, impostata dal supporto della tua piattaforma. Questa viene applicata al posto di questa tariffa.',
  title: 'Commissioni di elaborazione',
  subtitle:
    'La commissione di elaborazione che {{company}} paga sui pagamenti online, per coprire le commissioni di Stripe.',
  card_title: 'Commissione di elaborazione',
  status: {
    inherited_tag: 'Predefinita del partner',
    inherited: 'A questo ristorante viene applicata la tua commissione di elaborazione predefinita.',
    custom_tag: 'Personalizzata',
    custom: 'Questo ristorante ha una propria commissione di elaborazione, che sostituisce quella predefinita.',
    none_title: 'Nessuna commissione di elaborazione impostata',
    none: 'Né questo ristorante né la tua impostazione predefinita hanno una tariffa. Se non hai confermato un margine dello 0% nella pagina delle commissioni di elaborazione del partner, non può andare online né ricevere pagamenti online; con tale conferma non gli viene addebitato nulla e tu paghi le commissioni di Stripe sui suoi pagamenti.',
  },
  buttons: {
    set_custom: 'Imposta una commissione personalizzata',
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
    reset_to_default: 'Ripristina predefinita',
  },
  toasts: {
    load_error: 'Impossibile caricare la commissione di elaborazione.',
    failed_to_save_changes: 'Impossibile salvare la commissione di elaborazione.',
    changes_got_saved: 'Commissione di elaborazione salvata',
    reset_to_default: 'Questo ristorante ora usa la tua commissione di elaborazione predefinita.',
  },
};
